import React from "react"
import InputField from "@src/components/input-field"
const InputEmail = props => {
  return <InputField {...props} type="email" />
}
export default InputEmail
